import React, { useState } from "react";
import styles from "./audioPlayer.module.css";

const AudioPlayer = ({ audioUrl }) => {
  /* This component is used to play audio files */

  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = React.createRef();

  const playBtnSrc = process.env.PUBLIC_URL + "/images/websiteImages/play.png";
  const pauseBtnSrc =
    process.env.PUBLIC_URL + "/images/websiteImages/pause.png";

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleEnded = () => {
    setIsPlaying(false);
  };

  return (
    <div className={styles.audioPlayer}>
      <button onClick={togglePlay}>
        <img
          src={isPlaying ? pauseBtnSrc : playBtnSrc}
          alt={isPlaying ? "Pause" : "Play"}
        />
      </button>
      <audio ref={audioRef} src={audioUrl} onEnded={handleEnded} />
    </div>
  );
};

export default AudioPlayer;
